import { BeRow, BeStack, BeSwatch } from "@beos-css/react/index.ts";
import { useState } from "react";

const COLORS = ["#5a8e8e", "#ffcb00", "#0000ff", "#cc2222", "#d8d8d8"];

export function SwatchDemo() {
	const [picked, setPicked] = useState(COLORS[0] as string);

	return (
		<section id="demo-swatch">
			<h3>Swatch</h3>
			<p>
				A colour chip whose bevel is derived from its own colour with <code>color-mix</code>, reproducing BeOS's <code>shift_color()</code>{" "}
				— so any caller colour gets the authentic raised edge with no per-colour token. Four sizes; render a <code>&lt;button&gt;</code> by
				passing <code>onClick</code> to make it pickable. The segmented progress bar's legend and the kanban status chips are both this
				component.
			</p>
			<BeRow wrap gap="row">
				<BeStack className="be-panel be-fit" gap="item" pad="section">
					{(["mini", "small", "medium", "large"] as const).map((size) => (
						<BeRow key={size} align="center">
							<BeSwatch size={size} color="#5a8e8e" />
							<span>{size}</span>
						</BeRow>
					))}
				</BeStack>
				<BeStack className="be-panel be-fit" gap="item" pad="section">
					<BeRow gap="inset">
						{COLORS.map((c) => (
							<BeSwatch key={c} size="large" color={c} selected={picked === c} onClick={() => setPicked(c)} title={c} />
						))}
					</BeRow>
					<p>picked: {picked}</p>
				</BeStack>
			</BeRow>
		</section>
	);
}
